<h3 mat-dialog-title>
  <div class="title">
    <div>
      @if (hasCompanyLogo$ | async) {
        <img
          [src]="companyLogoService.getLogoSrcUrl(company.id)"
          alt="Logo de {{ company.name }}"
          class="company-logo"
        />
      }
    </div>

    <div [style.color]="color">
      {{ company.name }}
      @if (stateLabel) {
        <div class="company-state" data-test="company-state">{{ stateLabel }}</div>
      }
    </div>
    <div>
      <button
        mat-icon-button
        matTooltip="Choisir une couleur pour la société"
        aria-label="Choisir une couleur pour la société"
        (click)="toggleColorPicker = !toggleColorPicker"
        [disabled]="isReadOnly"
      >
        <div [(colorPicker)]="color" [(cpToggle)]="toggleColorPicker"></div>
        <mat-icon [style.color]="color">palette</mat-icon>
      </button>
    </div>
  </div>
</h3>
<mat-dialog-content>
  <p class="legal-entities-notice" data-test="legal-entities-notice">
    La raison sociale, la forme juridique, le siège, le SIREN, le SIRET, le RCS, le dossier du pôle
    social, le courriel et le téléphone de contact et le logo se modifient dans l'application des
    entités légales ; CDT les recopie.
  </p>
  <section>
    <h5>Informations légales</h5>
    <app-legal-information-form
      [initWith]="$safeNavigationMigration(company?.legalInformation)"
    ></app-legal-information-form>
  </section>
  <section>
    <h5>Contacts</h5>
    <div class="flex gap">
      <mat-form-field class="w-100" subscriptSizing="dynamic">
        <mat-label>Email de contact</mat-label>
        <input
          matInput
          [formControl]="emailControl"
          type="email"
          autocomplete="off"
          aria-describedby="company-contacts-hint"
        />
      </mat-form-field>
      <mat-form-field class="w-100" subscriptSizing="dynamic">
        <mat-label>Numéro de téléphone</mat-label>
        <input
          matInput
          [formControl]="phoneNumberControl"
          type="tel"
          autocomplete="off"
          aria-describedby="company-contacts-hint"
        />
      </mat-form-field>
    </div>
    <p id="company-contacts-hint" class="contacts-hint" data-test="contacts-hint">
      Le courriel et le téléphone de contact de la société se modifient dans l'application des
      entités légales.
    </p>
  </section>
  <section>
    <h5>Disque réseau</h5>
    <mat-form-field class="w-100" subscriptSizing="dynamic">
      <mat-label>Dossier réseau</mat-label>
      <input matInput [formControl]="vanexNetworkFolderNameControl" placeholder="7_VB Propreté" />
      <mat-hint data-test="vanex-network-folder-hint">
        Nom du dossier de la société dans le dossier POLE SOCIAL du disque réseau de Vanex (Z:), tel
        qu'il apparaît, préfixe compris. Il se modifie dans l'application des entités légales.
      </mat-hint>
    </mat-form-field>
  </section>
  <section>
    <h5>Organisme de retraite complémentaire</h5>
    <app-postal-address-form [formGroup]="retraiteComplementaireForm"></app-postal-address-form>
  </section>
  <section>
    <h5>Organisme de prévoyance</h5>
    <app-postal-address-form [formGroup]="prevoyanceForm"></app-postal-address-form>
  </section>
  <section>
    <h5>Horaires collectifs</h5>
    <app-schedules-form
      [initWith]="initSchedulesFormValue"
      [readOnly]="isReadOnly"
    ></app-schedules-form>
  </section>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="dialogRef.close()">Fermer</button>
  <app-save-button
    (click)="onSave()"
    [isEditMode]="true"
    [enabled]="isFormValid && !isReadOnly"
    matTooltip="Enregistrer les modifications"
  ></app-save-button>
</mat-dialog-actions>
